var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',{attrs:{"label":_vm.label,"custom-class":"my-input-field-label secondary-font"}},[_c('b-input',{attrs:{"custom-class":"my-input-field","type":'float',"disabled":_vm.disabled,"placeholder":_vm.placeholder},on:{"input":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }